import moment from "moment/moment";

const parseUtc = (date) => {
    return moment(moment(date).format('YYYY-MM-DD HH:mm:ss')).parseZone().toISOString();
};

export default parseUtc;
